import React from "react";
import { useAuth } from "../context/auth/useAuth";

const Login = () => {
  const { login, isLoading, error } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F7F7F8]">
      <div className="bg-white p-8 rounded-lg shadow-md w-96 border border-[#e2e2e2]">
        <h2 className="text-2xl text-[#243249] font-semibold mb-6 text-center">
          Welcome to AllSafe Robotics Management
        </h2>
        {error && (
          <p className="text-red-500 text-sm mb-4 text-center">
            {error.message}
          </p>
        )}
        <div className="text-center mb-6">
          <p className="text-[#596575] mb-4">
            Sign in securely with your authorized account
          </p>
        </div>
        <button
          onClick={login}
          disabled={isLoading}
          className="w-full bg-[#023058] text-white py-2 px-4 rounded-full hover:bg-[#001f3c] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? "Signing in..." : "Sign In"}
        </button>
      </div>
    </div>
  );
};

export default Login;
